import { Toolbar } from "@components-common/toolbar";
import { RootieTable } from "../tables/RootieTable";

type ScreenProps = any;

export const IndexContainer: React.FC<any> = (props: ScreenProps) => {
  const { toolbar, table } = props;
  return (
    <>
      <Toolbar {...toolbar} />
      <RootieTable {...table} />
    </>
  );
};
